import { useSearchParams } from "react-router-dom";
import {
  Camera,
  Check,
  Download,
  FileText,
  FolderOpen,
  BookOpen,
  MapPin,
  ChevronDown,
  Clock,
} from "lucide-react";
import styles from "./CheckListVisto.module.css";
import optionStyles from "./CheckListVisto.options.module.css";

const fotos = [
  "Foto no tamanho 5x5 ou 5x7",
  "Foto nítida e com boa qualidade",
  "Fundo branco e sem sombras",
  "Tirada há no máximo seis meses",
  "Não sorrir e manter a boca fechada",
  "Cabeça centralizada e olhar direto",
  "Orelhas expostas",
  "Nada cobrindo o rosto ou o cabelo",
  "Não usar óculos, chapéus ou bonés",
  "Cabelo preso e testa em evidência",
];
const biometria = [
  "Passaporte válido",
  "Documento de identidade/CNH",
  "Confirmação de submissão",
  "Carta de coleta biométrica",
  "Confirmação de agendamento",
  "Uma caneta",
  "Termo de consentimento",
];
const passaporte = [
  "Passaporte original e válido",
  "Carta de solicitação do passaporte",
  "Formulário de consentimento",
  "Se precisar do frete de retorno: uma folha com nome completo do aplicante, endereço de devolução com CEP, e-mail, telefone com DDD e comprovante de pagamento das taxas do serviço de retorno.",
];
const documentosPassaporteBrasil = [
  "Documento de identificação com foto",
  "CPF",
  "Título de eleitor",
  "Passaporte antigo (se houver)",
  "Detalhamento do agendamento em PDF",
  "Comprovante de quitação eleitoral",
  "Certidão de dispensa militar",
  "Certidão de casamento ou divórcio (se houver)",
  "Autorização dos pais assinada (menor de idade)",
  "Certidão de nascimento (menor de idade)",
];
const enderecosAmericanos = [
  { cidade: "Brasília", atendimento: ["Brasília CASV", "Aeroporto Internacional de Brasília, Presidente Juscelino Kubitschek, Área Especial S/N, Espaço 2.001 (mezanino).", "Brasília, Lago Sul, Distrito Federal - CEP: 71608-900"], consulado: ["Embaixada dos EUA", "SES - Avenida das Nações, Quadra 801, Lote 03, via L-2", "Brasília, DF - CEP: 70403-900"] },
  { cidade: "Porto Alegre", atendimento: ["Centro de Entrega de Documentos (CED)", "Av. Assis Brasil, 1712 - Passo d'Areia", "Porto Alegre, RS - CEP: 91010-001"], consulado: ["Consulado dos EUA", "Avenida Assis Brasil, 1889 – Passo D’Areia", "Porto Alegre, RS - CEP: 91010-004"] },
  { cidade: "Recife", atendimento: ["Centro de Entrega de Documentos (CED)", "R. Alfândega, 35, loja 220 - Shopping Paço Alfândega", "Recife, PE - CEP: 50030-030"], consulado: ["Consulado dos EUA", "Rua Gonçalves Maia, 163 - Bairro Boa Vista", "Recife, PE - CEP: 50070-060"] },
  { cidade: "Rio de Janeiro", atendimento: ["Rio de Janeiro CASV", "Avenida Almirante Silvio de Noronha, 365, Loja SS101 - Shopping Bossa Nova Mall", "Centro, Rio de Janeiro, RJ - CEP: 20021-010"], consulado: ["Consulado Geral dos EUA", "Avenida Presidente Wilson, 147 - Castelo", "Rio de Janeiro, RJ - CEP: 20030-020", "Entrada pela Rua Santa Luzia"] },
  { cidade: "São Paulo", atendimento: ["São Paulo #1 CASV", "Avenida José Maria Whitaker, 370 - Vila Mariana", "São Paulo, SP - CEP: 04057-000"], consulado: ["Consulado Geral dos EUA", "Rua Henri Dunant, 500 - Chácara Santo Antônio", "São Paulo, SP - CEP: 04709-110"] },
];
const enderecosCanadenses = [
  { cidade: "Brasília", linhas: ["Canada Visa Application Centre", "Capital Financial Center: Sudoeste, 1º andar, sala 116", "SIG, Quadra 04, Lotes 75/175, Bloco A", "Brasília, DF - CEP: 70610-440"], horario: "Segunda a sexta: 08:00 - 16:00" },
  { cidade: "Porto Alegre", linhas: ["Canada Visa Application Centre", "Rua Dom Pedro II, 367, 3º andar, sala 301", "Porto Alegre, RS - CEP: 90550-142"], horario: "Segunda a sexta: 08:00 - 16:00" },
  { cidade: "Recife", linhas: ["Canada Visa Application Centre", "Janete Costa Tower, 12º andar, salas 1201-1202", "Rua Padre Carapuceiro, 968", "Recife, PE - CEP: 51020-280"], horario: "Segunda a sexta: 08:00 - 16:00" },
  { cidade: "Rio de Janeiro", linhas: ["Canada Visa Application Centre", "Edifício Avenida Central, salas 2119-2120", "Av. Rio Branco, 156", "Rio de Janeiro, RJ - CEP: 20040-901"], horario: "Segunda a sexta: 09:00 - 17:00" },
  { cidade: "São Paulo", linhas: ["Canada Visa Application Centre", "Edifício Itamaraju Pinheiros, 5º andar, sala 53", "Rua Butantã, 434", "São Paulo, SP - CEP: 05424-000"], horario: "Segunda a sexta: 08:00 - 16:00" },
];

const Lista = ({ items }) => (
  <ul className={styles.lista}>
    {items.map((x) => (
      <li key={x}>
        <Check size={15} />
        <span>
          {x === "Comprovante de quitação eleitoral" ? (
            <>
              {x} —{" "}
              <a
                href="https://www.tse.jus.br/servicos-eleitorais/autoatendimento-eleitoral#/certidoes-eleitor?id=1760704811912"
                target="_blank"
                rel="noreferrer"
              >
                emitir no site do TSE
              </a>
            </>
          ) : (
            x
          )}
        </span>
      </li>
    ))}
  </ul>
);
const Baixar = ({ href, children }) => (
  <a className={styles.baixar} href={href} download>
    <Download size={18} />
    {children}
  </a>
);
const Enderecos = ({ tipo }) => {
  const americano = tipo === "americano";
  const enderecos = americano ? enderecosAmericanos : enderecosCanadenses;
  return (
    <article className={`${styles.card} ${optionStyles.enderecos}`}>
      <header className={optionStyles.enderecosCabecalho}>
        <span><MapPin /></span>
        <div><small>ENDEREÇOS DE ATENDIMENTO</small><h2>{americano ? "CASV, CED e consulados dos EUA" : "Centros de Solicitação de Visto do Canadá"}</h2><p>Selecione uma das cinco cidades para visualizar o endereço.</p></div>
      </header>
      <div className={optionStyles.cidades}>
        {enderecos.map((item) => (
          <details key={item.cidade}>
            <summary><span><MapPin size={18} /><strong>{item.cidade}</strong></span><ChevronDown size={20} /></summary>
            <div className={optionStyles.enderecoConteudo}>
              {americano ? <>
                <section><b>CASV / Entrega de documentos</b>{item.atendimento.map((linha, i) => i === 0 ? <strong key={linha}>{linha}</strong> : <span key={linha}>{linha}</span>)}</section>
                <section><b>Embaixada / Consulado</b>{item.consulado.map((linha, i) => i === 0 ? <strong key={linha}>{linha}</strong> : <span key={linha}>{linha}</span>)}</section>
              </> : <section>{item.linhas.map((linha, i) => i === 0 ? <strong key={linha}>{linha}</strong> : <span key={linha}>{linha}</span>)}<span className={optionStyles.horario}><Clock size={16} />{item.horario}</span></section>}
            </div>
          </details>
        ))}
      </div>
    </article>
  );
};

export default function CheckListVisto() {
  const [searchParams, setSearchParams] = useSearchParams();
  const visto = searchParams.get("visto");
  const pais = ["americano", "canadense", "passaporte"].includes(visto)
    ? visto
    : null;
  const etapa =
    searchParams.get("etapa") === "entrega" ? "passaporte" : "biometria";
  const alternarPais = (proximoPais) => {
    if (pais === proximoPais) return setSearchParams({});
    setSearchParams(
      proximoPais === "canadense"
        ? { visto: "canadense", etapa: "biometria" }
        : { visto: proximoPais },
    );
  };
  const selecionarEtapa = (proximaEtapa) =>
    setSearchParams({
      visto: "canadense",
      etapa: proximaEtapa === "passaporte" ? "entrega" : "biometria",
    });
  return (
    <main className={styles.pagina}>
      <header className={styles.hero}>
        <h1>Check-Lists</h1>
        <p>
          Escolha o objetivo e confira tudo o que precisa levar, imprimir ou
          baixar.
        </p>
      </header>
      <nav
        className={`${styles.paises} ${optionStyles.paisesOverride}`}
        aria-label="Selecione o visto"
      >
        <button
          aria-expanded={pais === "americano"}
          className={pais === "americano" ? styles.ativo : ""}
          onClick={() => alternarPais("americano")}
        >
          <img src="/icons/flag-us-svgrepo-com.svg" alt="" />
          <span>
            <strong>Visto americano</strong>
            <small>Checklist, fotos e entrevista</small>
          </span>
        </button>
        <button
          aria-expanded={pais === "canadense"}
          className={pais === "canadense" ? styles.ativo : ""}
          onClick={() => alternarPais("canadense")}
        >
          <img src="/icons/flag-ca-svgrepo-com.svg" alt="" />
          <span>
            <strong>Visto canadense</strong>
            <small>Biometria e passaporte</small>
          </span>
        </button>
        <button
          aria-expanded={pais === "passaporte"}
          className={pais === "passaporte" ? styles.ativo : ""}
          onClick={() => alternarPais("passaporte")}
        >
          <img src="/icons/flag-br-svgrepo-com.svg" alt="" />
          <span>
            <strong>Passaporte brasileiro</strong>
            <small>Orientações e documentos</small>
          </span>
        </button>
      </nav>

      
      {pais === "americano" ? (
        <section className={styles.conteudo}>
          <article className={styles.documento}>
            <FileText />
            <div>
              <small>PDF DE APOIO</small>
              <h2>Check-list do visto americano</h2>
              <p>Baixe o PDF para ajudar a sua preparação.</p>
            </div>
            <Baixar href="/arquivos/checklist-visto-americano.pdf">
              Baixar checklist PDF
            </Baixar>
          </article>
          <div className={styles.guias}>
            <article className={styles.card}>
              <h2>
                <Camera /> Guia de fotos
              </h2>
              <h3>Fotos impressas com fundo branco</h3>
              <p className={styles.aviso}>
                Obrigatório levar foto impressa em{" "}
                <b>RECIFE ou PORTO ALEGRE.</b> Em Brasília, SP e RJ há CASV para
                foto presencial.
              </p>

              <div>
                <div
                  style={{
                    display: "flex",
                    gap: "1rem",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src="/icons/rosto.webp"
                    alt="Exemplo de foto 5 por 5 centímetros"
                    style={{
                      width: "100%",
                      maxWidth: "400px",
                      borderRadius: "15px",
                      margin: "5px",
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "1rem",
                    justifyContent: "center",
                  }}
                >
                  <span>
                    <b>5 × 5 cm</b>
                  </span>
                  <span>
                    <b>5 × 7 cm</b>
                  </span>
                </div>
              </div>
              <Lista items={fotos} />
            </article>



          </div>
          <Enderecos tipo="americano" />
        </section>


      ) : pais === "canadense" ? (
        <section className={styles.conteudo}>
          <div className={styles.etapas}>
            <button
              className={etapa === "biometria" ? styles.etapaAtiva : ""}
              onClick={() => selecionarEtapa("biometria")}
            >
              <FolderOpen />
              <span>
                <strong>Coleta de biometria</strong>
                <small>Documentos para o atendimento</small>
              </span>
            </button>
            <button
              className={etapa === "passaporte" ? styles.etapaAtiva : ""}
              onClick={() => selecionarEtapa("passaporte")}
            >
              <FileText />
              <span>
                <strong>Entrega do passaporte</strong>
                <small>Documentos para envio</small>
              </span>
            </button>
          </div>
          <article className={styles.canada}>
            <small>{etapa === "biometria" ? "ETAPA 1" : "ETAPA 2"}</small>
            <h2>
              {etapa === "biometria"
                ? "Checklist para coleta de biometria"
                : "Checklist para entrega do passaporte"}
            </h2>
            <p>
              {etapa === "biometria"
                ? "Imprima e separe os documentos em uma pasta por pessoa."
                : "Separe os documentos por pessoa, em envelopes individuais."}
            </p>
            <Lista items={etapa === "biometria" ? biometria : passaporte} />
            <div className={styles.consentimento}>
              <span>
                <strong>Formulário de consentimento</strong>
                <small>Arquivo editável em Word (.docx)</small>
              </span>
              <Baixar href="/arquivos/formulario-consentimento-canada.docx">
                Baixar formulário
              </Baixar>
            </div>
          </article>
          <Enderecos tipo="canadense" />
        </section>


      ) : pais === "passaporte" ? (
        <section className={styles.conteudo}>
          <article
            className={`${styles.canada} ${optionStyles.passaporteBrasil}`}
          >
            <span className={optionStyles.passaporteIcon}>
              <BookOpen size={30} />
            </span>
            <small>PASSAPORTE BRASILEIRO</small>
            <h2>Documentos para levar ao posto da Polícia Federal</h2>
            <p>Separe os documentos abaixo antes do atendimento.</p>
            <Lista items={documentosPassaporteBrasil} />
            <div className={styles.consentimento}>
              <span>
                <strong>Autorização para menores</strong>
                <small>Formulário em PDF para menores de idade</small>
              </span>
              <Baixar href="/arquivos/autorizacao-passaporte-menor.pdf" style={{ color: "#fff" }}>
                Baixar autorização
              </Baixar>
            </div>
          </article>
        </section>
      ) : null}
    </main>
  );
}
